import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/services/data.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.less'],
    standalone: false
})
export class FooterComponent implements OnInit {

  showYear!: number;
  oemName!: string;
  rtlLocale = '';
  constructor(
    private router: Router,
    private dataService: DataService,
    private translate: TranslateService
  ) {
    if (this.translate.currentLang === 'melco/ar'
      || this.translate.currentLang === 'mitsubishi/ar'
      || this.translate.currentLang === 'melco/ar'
      || this.translate.currentLang === 'iveco/ar' || this.translate.currentLang === 'iveco/he_IL') {
      this.rtlLocale = 'rtl';
    } else {
      this.rtlLocale = 'non-rtl';
    }
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      if (this.translate.currentLang === 'melco/ar'
        || this.translate.currentLang === 'mitsubishi/ar'
        || this.translate.currentLang === 'iveco/ar' || this.translate.currentLang === 'iveco/he_IL') {
        this.rtlLocale = 'rtl';
      } else {
        this.rtlLocale = 'non-rtl';
      }
    });
  }

  ngOnInit(): void {
    this.oemName = this.dataService.getOemName();
    this.showYear = new Date().getFullYear();
  }

  routeToCopyright() {
    if (this.oemName !== 'opel') {
      this.router.navigate(['/downloads/copyright']);
    }
  }

}
